import { render, staticRenderFns } from "./DicBeGoodAtNewModal.vue?vue&type=template&id=27dc5a95&"
import script from "./DicBeGoodAtNewModal.vue?vue&type=script&lang=js&"
export * from "./DicBeGoodAtNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports